import React from "react";
import "./WhatsAppButton.css";

const WHATSAPP_NUMBER = "919781706262";
const WHATSAPP_MESSAGE = encodeURIComponent(
  "Hello! I am interested in learning more about Lyallpur Khalsa College Technical Campus & Courses.",
);

const WhatsAppButton = () => {
  const handleClick = () => {
    window.open(
      `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`,
      "_blank",
      "noopener,noreferrer",
    );
  };

  return (
    <div className="whatsapp-float-wrapper">
      <button
        className="whatsapp-pill-btn"
        onClick={handleClick}
        aria-label="Chat with us on WhatsApp"
        title="Chat with us on WhatsApp"
      >
        {/* Animated ping ring */}
        <span className="whatsapp-ping" />

        {/* WhatsApp Icon */}
        <span className="whatsapp-icon-wrap">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
            width="26"
            height="26"
            fill="white"
          >
            <path d="M16 0C7.163 0 0 7.163 0 16c0 2.833.738 5.489 2.027 7.8L0 32l8.418-2.005A15.93 15.93 0 0 0 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.333a13.27 13.27 0 0 1-6.77-1.851l-.486-.29-5.002 1.313 1.335-4.876-.32-.5A13.25 13.25 0 0 1 2.667 16C2.667 8.636 8.636 2.667 16 2.667S29.333 8.636 29.333 16 23.364 29.333 16 29.333zm7.3-9.967c-.4-.2-2.367-1.167-2.733-1.3-.367-.133-.633-.2-.9.2-.267.4-1.033 1.3-1.267 1.567-.233.267-.467.3-.867.1-.4-.2-1.7-.627-3.233-1.993-1.193-1.067-2-2.373-2.233-2.773-.233-.4-.025-.617.175-.817.18-.18.4-.467.6-.7.2-.233.267-.4.4-.667.133-.267.067-.5-.033-.7-.1-.2-.9-2.167-1.233-2.967-.325-.778-.657-.673-.9-.685H10.3c-.267 0-.7.1-1.067.5S8 10.9 8 13.633s2.1 5.7 2.4 6.1c.3.4 4.133 6.3 10.017 8.833 1.4.6 2.49.967 3.343 1.24 1.407.45 2.687.386 3.697.233 1.128-.17 3.467-1.417 3.957-2.783.49-1.367.49-2.54.343-2.783-.147-.243-.4-.343-.807-.543z" />
          </svg>
        </span>

        {/* Text */}
        <span className="whatsapp-text-wrap">
          <span className="whatsapp-text-main">Chat on WhatsApp</span>
          <span className="whatsapp-text-sub">We reply instantly!</span>
        </span>
      </button>
    </div>
  );
};

export default WhatsAppButton;
